import type { TherapistBlogPost } from "@/types";

// GET /api/blog čita pretragu iz `q` (ne `search`), a `limit` je najviše 50.
export const BLOG_LIST_MAX_LIMIT = 50;

export function blogListParams(opts: {
  page: number;
  limit: number;
  status?: string;
  q?: string;
  authorId?: string;
}): URLSearchParams {
  const params = new URLSearchParams({ page: String(opts.page), limit: String(opts.limit) });
  if (opts.status) params.set("status", opts.status);
  if (opts.q) params.set("q", opts.q);
  if (opts.authorId) params.set("authorId", opts.authorId);
  return params;
}

type BlogListPage<T> = { data: T[]; total: number; page: number };

/**
 * Svi članci autora, stranicu po stranicu (API ne vraća više od 50 odjednom).
 * Treba za sažetak po statusu: obični korisnik ne može filtrirati po statusu
 * osim `published`, pa se brojevi računaju iz cijele liste.
 */
export async function fetchAllAuthorPosts<T = TherapistBlogPost>(
  authorId: string,
  fetchPage: (params: URLSearchParams) => Promise<BlogListPage<T>>,
): Promise<T[]> {
  const all: T[] = [];
  for (let page = 1; ; page++) {
    const res = await fetchPage(blogListParams({ page, limit: BLOG_LIST_MAX_LIMIT, authorId }));
    all.push(...res.data);
    if (res.data.length === 0 || all.length >= res.total) return all;
  }
}
